export function setState(Element, selector) {
    const kompo = Element.kompo;
    kompo.selector = selector;
    return Element;
}
export function getState(Element) {
    const selector = Element.kompo.selector;
    return selector ?
        selector(Element.__kompo__.state) :
        Element.__kompo__.state;
}
export function getSelector(Element) {
    return Element.kompo.selector;
}
//# sourceMappingURL=state.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kompo/lib/component/state.js
// module id = 0
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11